/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = void 0;
  var y = void 0;

  x = region.left;
  y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

export default getAlignOffset;


//////////////////
// WEBPACK FOOTER
// ./~/dom-align/es/getAlignOffset.js
// module id = ./node_modules/dom-align/es/getAlignOffset.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons